"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatQueryParams = formatQueryParams;

var _qs = _interopRequireDefault(require("qs"));

var _curryRight = _interopRequireDefault(require("lodash/curryRight"));

var _functools = require("@edison/functools");

var _datetime = require("./datetime");

var _format = require("./format");

/**
 * Formats the query string for appending into a URL.
 */
function formatQueryParams(url, params) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _format$snakify = format.snakify,
      snakify = _format$snakify === void 0 ? true : _format$snakify,
      _format$arrayFormat = format.arrayFormat,
      arrayFormat = _format$arrayFormat === void 0 ? 'indices' : _format$arrayFormat;
  var q = (0, _functools.pipe)(function (params) {
    if (snakify) {
      return (0, _format.snakify)(params, []);
    }

    return params;
  }, _datetime.demomentize, (0, _curryRight["default"])(_qs["default"].stringify)({
    arrayFormat: arrayFormat
  }))(params);
  return "".concat(url, "?").concat(q);
}
//# sourceMappingURL=url.js.map